/**
 * These typography values are merged with the common typography theme
 */

const fontFamilyWorkSans = ['"Work Sans"', "sans-serif"].join(",");
const fontFamilyInter = ['"Inter"', "sans-serif"].join(",");
const fontFamilyOpenSans = ['"Open Sans"', "sans-serif"].join(",");

// Need to specify fontFamily when creating the theme
// so that mui will set the default for all typography
const defaults = {
  typography: {
    fontFamily: fontFamilyWorkSans,
    fontFamilySecondary: fontFamilyInter,
    fontFamilyOpenSans: fontFamilyOpenSans,
  },
};

const typography = (_theme: any) => ({
  typography: {},
});

export { defaults };
export default typography;
